module.exports = __webpack_public_path__ + "1efd75c7458ea4727d4c1660bd0e93ac.jpg";